<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import { maxLength, minLength, required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import debounce from 'lodash.debounce'
import { CLICK_TO_PAY } from '../../../../utils/constant.js'
import sharedService from '../../../../utils/shared-service'

Vue.use(Vuelidate)

export default {
  name: 'SecurityInformation',
  directives: { mask },

  props: {
    paymentMode: {
      type: String
    }
  },

  data () {
    return {
      expiry: '',
      cvc2: '',
      expiryDateValueErr: false,
      cvc2Error: false
    }
  },

  validations: {
    expiry: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(5)
    },

    cvc2: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(4)
    }

  },

  watch: {
    paymentMode: {
      handler () {
        if (this.paymentMode === CLICK_TO_PAY) {
          this.expiry = ''
          this.expiryDateValueErr = ''
          this.cvc2 = ''
        }
      }
    }
  },

  methods: {
    /**
     * This methods emits the expiry date
     * @param event
     */
    emitExpiry (event) {
      debounce(() => {
        if (event === '1/') {
          this.expiry = '01/'
        }
        if (event === '00') {
          this.expiry = '01/'
        }
        if (event >= '13') {
          this.expiry = '0' + event.split('')[0] + '/' + event.split('')[1]
        }
        if (event > '1' && event <= '9' && (event.length === 1)) {
          this.expiry = '0' + event + '/'
        }
      }, 10)()

      this.expiryDateValueErr = sharedService.validateExpiryDate(this.expiry)
      this.cvc2Error = sharedService.validateCVV(this.cvc2)
      if (!this.expiryDateValueErr || !this.cvc2Error) {
        this.setValidatedInput()
      }
    },

    /**
     * emits the expiry and splits in MM/YY
     */
    setValidatedInput () {
      if (!!this.expiry && !!this.cvc2) {
        this.$emit('input', {
          month: this.expiry.split('/')[0],
          year: this.expiry.split('/')[1],
          cvc2: this.cvc2
        })
      }
    }
  }
}
</script>

<template>
  <div>
    <div class="form-row mb-3">
      <div class="col">
        <input
          v-mask="'##/##'"
          id="input-card-expiry"
          v-model="expiry"
          :label="'Card Expiry'"
          :placeholder="'Expiry (MM/YY)'"
          class="form-control input-lg pr-0"
          data-test="expiry-date"
          name="expiry"
          type="text"
          @input="emitExpiry(expiry)"
        >
        <small
          v-if="expiryDateValueErr"
          id="cardExpiryError"
          class="form-text text-danger"
        >
          {{ $t('errorMessages.invalidExpiryDate') }}
        </small>
      </div>
      <div class="col">
        <input
          v-mask="'####'"
          id="input-secure-code"
          v-model="cvc2"
          :label="'Security code'"
          :placeholder="'Security code'"
          class="form-control input-lg"
          data-test="secure-code"
          name="secure-code"
          type="text"
          @input="emitExpiry()"
        >
        <small
          v-if="!$v.cvc2.minLength || !$v.cvc2.maxLength || cvc2Error"
          id="cardCVCError"
          class="form-text text-danger"
        >
          {{ $t('errorMessages.invalidSecureCode') }}
        </small>
      </div>
    </div>
  </div>
</template>
